import { useState } from "react";
import { AnnotatedItem } from "./types";

interface Props {
	image: string;
	alt: string;
	width: number;
	height: number;
	items: AnnotatedItem[];
	inline: (text: string) => React.ReactNode;
}

const icon = (name: string) => `/images/icons/${name}.svg`;

/** App screenshot with lettered markers; selecting a marker or a legend entry highlights the other. */
export default function Annotated({ image, alt, width, height, items, inline }: Props) {
	const [active, setActive] = useState<string | null>(null);
	const toggle = (id: string) => setActive((a) => (a === id ? null : id));

	return (
		<div className="faq-annot">
			<ul className="faq-annot__legend">
				{items.map((it) => (
					<li key={it.icon}>
						<button
							type="button"
							className={`faq-annot__row${active === it.icon ? " is-active" : ""}`}
							aria-pressed={active === it.icon}
							onClick={() => toggle(it.icon)}
						>
							<img src={icon(it.icon)} alt="" width={24} height={24} />
							<span>
								<strong>{it.title}</strong>
								{it.text && <> {inline(it.text)}</>}
							</span>
						</button>
					</li>
				))}
			</ul>
			<div className="faq-annot__shot" style={{ maxWidth: width, aspectRatio: `${width} / ${height}` }}>
				<img className="faq-annot__image" src={image} alt={alt} loading="lazy" />
				{items
					.filter((it) => it.x !== undefined && it.y !== undefined)
					.map((it) => (
						<button
							key={it.icon}
							type="button"
							className={`faq-annot__marker${active === it.icon ? " is-active" : ""}`}
							style={{ left: `${((it.x as number) / width) * 100}%`, top: `${((it.y as number) / height) * 100}%` }}
							aria-label={it.title}
							aria-pressed={active === it.icon}
							onClick={() => toggle(it.icon)}
						>
							<img src={icon(it.icon)} alt="" />
						</button>
					))}
			</div>
		</div>
	);
}
